export default __webpack_public_path__ + "static/media/1.6cc3205d.jpg";